import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../../../common/breadcrumbs";
import Loader from "../../../../common/loader";
import { capitalizeFirstLetter, formateDate, showStatus } from "../../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { DetailsCenterService } from "../../../../services/usermgmt.services";

const CenterServiceView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { center_id } = useLocation().state;
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const breadcrumbs = [
      { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard/1" },
      {
          title: t("Center Management"),
          url: "/admin/center-management/center/list/1",
      },
      {
          title: "Center Services",
          url: `/admin/center-management/center/service/${center_id}/list/1`,
      },
      { title: t("admin.faq.link_view"), url: "" },
  ];

  // const selected_language = localStorage.getItem("system_language")
  // console.log(selected_language)

  useEffect(() => {
    DetailsCenterService(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);


  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("View banner")}</h6>
              </div>
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>

                        <tr>
                          <th>{t("admin.faq.list_heading_title")} </th>
                          <td className="text-capitalize word-break">
                            {showdefault && showdefault?.title
                              ? capitalizeFirstLetter(showdefault.title)
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("admin.faq.label_status")}</th>
                          <td>
                            {showdefault && showdefault?.status === 0
                              ? toHtml(showStatus(showdefault.status))
                              : toHtml(showStatus(showdefault.status))}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("admin.list_heading.list_heading_created_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDate(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                         <tr>
                        <th>Image</th>
                        <td>
                          <img
                            src={
                              showdefault && showdefault.image
                                ? showdefault.image
                                : "N/A"
                            }
                            alt="bnner-image"
                            style={{ height: "100px" }}
                          />
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <h6 className="main-content-label mb-3">{t("admin.faq.label_description")}:</h6>
                    {/* <div className="">{toHtml(showdefault && showdefault.description ? showdefault.description : "N/A")}</div> */}
                    <div className="text-capitalize"
                      dangerouslySetInnerHTML={{
                        __html:
                          showdefault && showdefault?.description
                            ? showdefault.description
                            : "N/A",
                      }}
                    ></div>
                    <div className="mt-5">
                      <button
                        className="btn ripple btn-dark"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("admin.button.btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CenterServiceView;